import { render, staticRenderFns } from "./ExcluirCertificadoDigitalModal.vue?vue&type=template&id=52c29ea2&scoped=true&"
import script from "./ExcluirCertificadoDigitalModal.vue?vue&type=script&lang=js&"
export * from "./ExcluirCertificadoDigitalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c29ea2",
  null
  
)

export default component.exports